module.exports = __webpack_public_path__ + "static/media/boomplay.f46db25b.svg";